/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from 'react';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import { toAbsoluteUrl } from '../../_metronic/helpers';
import { ChangePassword } from './components/ChangePassword';
import { ForgotPassword } from './components/ForgotPassword';
import { Login } from './components/Login';
import { NewPassword } from './components/NewPassword';
import { Registration } from './components/Registration';

export function AuthPage() {
  const location = useLocation();
  const { pathname } = location;
  const trimmedPathname = pathname.replace(/^\//, '');
  useEffect(() => {
    document.body.classList.add('bg-white');
    return () => {
      document.body.classList.remove('bg-white');
    };
  }, []);

  return (
    <div
      className="d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed"
      style={{
        backgroundImage: `url(${toAbsoluteUrl('/media/illustrations/progress-hd.png')})`,
      }}
    >
      {/* begin::Content */}
      <div className="d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20">
        {/* begin::Logo */}

        {/* end::Logo */}
        {/* begin::Wrapper */}
        <div className="w-lg-500px bg-white rounded shadow-sm p-10 p-lg-15 mx-auto">
          <Switch>
            <Route path="/auth/login" component={Login} />
            <Route path="/auth/registration" component={Registration} />
            <Route path="/auth/forgot-password" component={ForgotPassword} />
            <Route path="/auth/change-password" component={ChangePassword} />
            <Route path="/yenisifre/:hash" component={NewPassword} />
            {trimmedPathname !== '/auth/login' && <Redirect from="/auth" exact={true} to={`/dashboard?redirect=${trimmedPathname}`} />}
            <Redirect from="/auth" exact={true} to={`/auth/login?r=${trimmedPathname}`} />
            {trimmedPathname ? <Redirect to={`/auth/login?redirect=${trimmedPathname}`} /> : <Redirect to={`/auth/login`} />}
          </Switch>
        </div>
        {/* end::Wrapper */}
      </div>
      {/* end::Content */}
      {/* begin::Footer */}
      {/* end::Footer */}
    </div>
  );
}
